import * as React from "react";
import { UserProvider, prefetchCurrentUser } from "@/stores/CurrentUser.tsx";
import { useIsLoggedIn } from "@/stores/LoggedInStatus.ts";
import { prefetchPrivacyNotice } from "@/stores/PrivacyNotice.ts";
import { getCvPartner, skipFetchingUser } from "@/util/getCvPartner.ts";
import { Logo } from "./Logo.tsx";
import { Navigation } from "./Navigation.tsx";
import { container, mainNav } from "./index.css.ts";

export { headerHeight } from "./index.css.ts";

function useSkipFetchingUser() {
  const isLoggedIn = useIsLoggedIn();

  const [currentPath, setCurrentPath] = React.useState(
    () => window.location.pathname,
  );

  React.useEffect(() => {
    return getCvPartner().subscribeToRouter(() => {
      setCurrentPath(window.location.pathname);
    });
  }, []);

  if (!isLoggedIn) {
    return true;
  }

  return skipFetchingUser(currentPath);
}

export const Header: React.FC = () => {
  const skipFetchingUser = useSkipFetchingUser();
  const isLoggedIn = useIsLoggedIn();

  React.useEffect(() => {
    if (!skipFetchingUser) {
      Promise.all([prefetchCurrentUser(), prefetchPrivacyNotice()]);
    }
  }, [skipFetchingUser]);

  return (
    <header className={mainNav}>
      <div className={container}>
        <Logo />
        {isLoggedIn && (
          <UserProvider>
            <Navigation />
          </UserProvider>
        )}
      </div>
    </header>
  );
};
